import { render } from "./DocumentTabletFormComponent.vue?vue&type=template&id=4367ce6c"
import script from "./DocumentTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./DocumentTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__